export const ErrorsStablecoin = {
  CONFLICT: 'La activación de esta cuenta ya está en proceso.',
  ACCOUNT_ALREADY_EXISTS: 'Ya existe una billetera para esta moneda.',
} as const;
